export default __webpack_public_path__ + "static/media/te-ppe-01.bfc1a247.png";